"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewProductModelClient = void 0;
var defaultOptions = { version: 'latest' };
var defaultClientOptions = {
    baseUrl: 'https://schema.product-model.manage.rackspace.com',
    cache: new Map(),
    cacheExpirationSeconds: 30 * 60,
    fetch: globalThis.fetch,
};
var headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};
function NewProductModelClient(clientOptions) {
    var _this = this;
    if (clientOptions === void 0) { clientOptions = defaultClientOptions; }
    var mergedClientOptions = Object.assign({}, defaultClientOptions, clientOptions);
    var getProducts = function (options) {
        if (options === void 0) { options = defaultOptions; }
        return __awaiter(_this, void 0, void 0, function () {
            var mergedOptions, version, result, isExpired, _a, fetchProducts;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        mergedOptions = Object.assign({}, defaultOptions, options);
                        version = mergedOptions.version;
                        result = mergedClientOptions.cache.get(version);
                        isExpired = result && result.expiration < Date.now();
                        if (!(result && result.data && !isExpired)) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, result.data];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        mergedClientOptions.cache.delete(version);
                        result = null;
                        return [3 /*break*/, 4];
                    case 4:
                        if (!result || isExpired) {
                            fetchProducts = function () { return __awaiter(_this, void 0, void 0, function () {
                                var href, response;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            href = version === defaultOptions.version
                                                ? "/catalog/schemas/product-model/products.json"
                                                : "/catalog/schemas/product-model-".concat(version, "/products.json");
                                            return [4 /*yield*/, mergedClientOptions.fetch("".concat(mergedClientOptions.baseUrl).concat(href), { headers: headers })];
                                        case 1:
                                            response = _a.sent();
                                            if (!response.ok) {
                                                throw new Error("Failed to fetch products from ".concat(mergedClientOptions.baseUrl).concat(href));
                                            }
                                            return [2 /*return*/, response.json()];
                                    }
                                });
                            }); };
                            result = {
                                expiration: Date.now() + mergedClientOptions.cacheExpirationSeconds * 1000,
                                data: fetchProducts(),
                            };
                            mergedClientOptions.cache.set(version, result);
                        }
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    var getProduct = function (id, options) {
        if (options === void 0) { options = defaultOptions; }
        return __awaiter(_this, void 0, void 0, function () {
            var products;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getProducts(options)];
                    case 1:
                        products = _a.sent();
                        if (!products[id]) {
                            throw new Error("Product ".concat(id, " not found from S3"));
                        }
                        return [2 /*return*/, {
                                sha: products.sha,
                                product: products[id],
                            }];
                }
            });
        });
    };
    return {
        getProducts: getProducts,
        getProduct: getProduct,
    };
}
exports.NewProductModelClient = NewProductModelClient;
